import _CasesSection from "./_components/cases-section";
import _CasesPanel from "./_components/cases-panel";

const Cases = _CasesSection;
export default Cases;
export const CasesPanel = _CasesPanel;
